import USER_CONSTANTS from "../constants/userConstants";
import entity from "../utils/stores/entity";

let userStore = {
    getInitialState() {
        return {
            addressData: this.app.data.address || {},
            cancelledOrders: {}
        };
    },
    handlers: {
        cancelOrder: [
            USER_CONSTANTS.CANCEL_ORDER_DONE,
        ]
    },
    cancelOrder(data) {
        this.state.cancelledOrders[data.recID] = true;
        this.hasChanged();
    },
    isOrderCancelled(id) {
        return !!this.state.cancelledOrders[id];
    },
    fetchAddressData() {
        return this.state.addressData;
    }
};

export default entity(userStore, USER_CONSTANTS);



/** WEBPACK FOOTER **
 ** ./app/stores/userStore.js
 **/